import React, { useState } from 'react';
import { quicklinksDropdown } from "../Components/DropdownNavItems"
import { Link } from 'react-router-dom';
import "../index.css"

const QuicklinksDropdown = () => {
    const [dropDown, setDropDown] = useState(false)
    return (
        <div>
            <>
                <ul className={dropDown ? "quicklinks-submenu clicked": "quicklinks-submenu"} onClick={() => setDropDown(!dropDown)}>
                    {
                        quicklinksDropdown.map(item => {
                            return (
                                <li key={item.id}>
                                    <Link to={item.path} className={item.cName} onClick={() => setDropDown(false)}>{item.title}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </>
        </div>
    );
}

export default QuicklinksDropdown;
